import styled from 'styled-components/macro'
import { theme } from 'styled-tools'
import { media } from 'ui/rwd'
import { Section } from '../HomepageStyledComponents'

const HeroSection = styled(Section)`
  display: flex;
  flex-direction: column-reverse;
  gap: 2.5rem;
  padding-top: 2rem;
  padding-bottom: 2.5rem;
  ${media.sm`
    gap: 3rem;
    padding-top: 3rem;
    padding-bottom: 3.5rem;
  `}
  ${media.md`
    flex-direction: row;
    align-items: center;
    gap: 3.5rem;
    padding-top: 5rem;
    padding-bottom: 5rem;
  `}
`

const HeroDescription = styled.div`
  position: relative;
  z-index: 1;
  min-width: 0;
  text-align: left;
  max-width: 45rem;
  ${media.md`
    flex: 52 1 0;
    max-width: none;
  `}
`

const HeroTitle = styled.h1`
  margin: 0;
  overflow-wrap: break-word;
  font-size: 2.25rem;
  font-weight: bold;
  line-height: 1.1;
  letter-spacing: -0.02em;
  ${media.sm`
    font-size: 2.5rem;
  `}
  ${media.md`
    font-size: 2.625rem;
  `}
`

const HeroBody = styled.p`
  max-width: 38rem;
  margin: 1.25rem 0 0;
  font-size: 1.0625rem;
  line-height: 1.6;
  color: ${theme('midGray')};
  ${media.sm`
    font-size: 1.125rem;
  `}
`

const CtaRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 2rem;

  > * {
    width: 100%;
    box-sizing: border-box;
    text-align: center;
  }

  ${media.sm`
    flex-direction: row;
    flex-wrap: wrap;

    > * {
      width: auto;
    }
  `}
`

export {
  HeroSection,
  HeroDescription,
  HeroTitle,
  HeroBody,
  CtaRow
}
